// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-AccountSetting-EmailNotification-Header-__Header___3kB8e"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/AccountSetting/EmailNotification/Header/Header.css
// module id = 2285
// module chunks = 0